import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
export default class BusinessPhotoGallery extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessGallery;
        this.displayName = "Venue Gallery ";
        this.dropList = defaultDropList;
        this.editList = [ "galleryLayout", componentAttributeTypes.multiLocation, componentAttributeTypes.layoutId, ...CreateAttributeList(true, false, true, true, false,false,false)];
        this.resizeType = ResizeableType.HorizontalOnly;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation, "galleryLayout"];
        this.contentEditable = false;
        this.vagaroLink = "https://www.vagaro.com/merchants/settings/lookandfeel/photogallery"
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512" fill="currentColor"><path d="M512 64V288H64L64 64H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM0 448v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512z" /></svg>
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [new AttributeDefinition("galleryLayout", "Layout", "", AttributeInputType.SelectField, [
            { label: "Default", value: "default" },
            { label: "Grid", value: "2" },
            { label: "Quad Shapes", value: "3" },
            { label: "Mosaic Columns", value: "4" },
        ]),
        ]
    }

    GetComponentGlobalCSS(node: LayoutNode, isEditor?: boolean): string {
        return getStyling();
    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const atts = GetNodeDomAttributes("v-photo-gallery flex-row max-w-100 clamp-height w-full gap-small resizable-container vb-control ", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, "galleryLayout", "1");
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);

        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="gallery" layout={layout} classNames={atts.className} />
        }

        return (
            <><style>{getStyling()}</style>
                <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="gallery" node={component} userContext={siteData} />
                </div>
            </>
        )
    }
}

function getStyling() {


    return `
        .photo-card{
            height:200px;
        }
        @media (max-width: 767px) {
            .photo-card {
               height:120px;
            }
        }
        @container (max-width: 767px) {
            .photo-card {
               height:120px;
            }
        }
 

        
    
    `
}